<template>
  <h2 class="my-8">
    <slot name="default"> TITLE </slot>
    <span v-if="$slots.subtitle" class="text-sm text-muted-foreground block font-normal">
      <slot name="subtitle" />
    </span>
  </h2>
</template>
